export function isAnyPlayerAbsentInStackItem(stackItem, players): boolean {
    const {playerIdsInPrimaryGroup, playerIdsInSecondaryGroup} = stackItem.data;

    for (let playerId of [...playerIdsInPrimaryGroup, ...playerIdsInSecondaryGroup]) {
        if (players.getPlayer(playerId) === null) {
            return true;
        }
    }

    return false;
}
